module.exports = __webpack_public_path__ + "static/media/Чепурной Даниил Рафаэлевич_Урок из прошлого_Курская обл.-08.png";